<!--病例实战 -->
<template>
    <div class="case-list-section">
        <div class="case-list-section-box" @click="go(dataItem)">
            <div class="case-list-section-left">
                <van-image class="case-list-section-left-img" fit="cover" :src="dataItem.content.cover_img" />
            </div>
            <div class="case-list-section-right">
                <div class="case-list-section-right-title" v-html="dataItem.content.title"></div>
                <div class="case-list-section-right-detail" v-if="dataItem.content.type == 2">
                    共{{ dataItem.content.total_count }}篇
                    <span>{{ dataItem.content.view_count }}人阅读</span>
                    <span class="case-list-section-right-detail-join" v-if="dataItem.content.is_subscribe === 0" @click.stop="attention(dataItem.content,dataItem)">
                        <img src="static/v4/icon_follow.svg" style="margin-right: 2px"/>关注
                    </span>
                    <span v-else class="case-list-section-right-detail-join1" @click.stop="attention(dataItem.content,dataItem)">已关注</span>
                </div>
                <div class="case-list-section-right-detail" v-else>
                    <span>{{ dataItem.content.created_at.substr(0,14)}}</span>
                    <span>{{ dataItem.content.view_count }}人阅读</span>
                </div>
            </div>
            <div class="clear"></div>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    name: "case",
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    methods: {
        // 关注/未关注
        attention(content,item) {
            // is_subscribe 0 未关注  1 已关注
            if (content.is_subscribe == 0) {
                // 取消关注
                this.$dialog
                    .confirm({
                        title: '提醒',
                        message: '确定取消关注吗？',
                        confirmButtonText: '确定',
                        className: 'dly-dialog'
                    })
                    .then(() => {
                        Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                            if (res.code == 0) {
                                this.$toast.success('取消关注成功')
                                content.is_subscribe = 1
                                this.$parent.tabClick()
                            }
                        })
                    })
                    .catch(() => {
                        console.log(1)
                    })
            } else {
                // 关注
                Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                    if (res.code == 0) {
                        this.$toast.success('关注成功')
                        content.is_subscribe = 0
                        this.$parent.tabClick()
                    }
                })
            }
        },
        go(item) {
            Interface.goArticle(this, {
                id: item.origin_id,
                type: item.content.type,
            })
        }
    }
}
</script>

<style scoped lang="scss">
@import "@/components/case-list-new.scss";
.case-list-section-box{
    width: 355px;
    background: #fff;
    margin: 0 auto;
    border-radius: 8px;
    margin-top: 10px;
}
.case-list-section-left{
    padding-left: 12px;
}
.case-list-section-right{
    padding-right: 12px;
}
.case-list-section-right-detail{
    align-items: center;
}
/deep/ .light {
    color: #D81D20;
}
</style>



// WEBPACK FOOTER //
// src/components/contentSelection/modules/case.vue